// Import model
import { StartProjectScheduleAppointmentRequest } from '../models/StartProjectScheduleAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectScheduleAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectScheduleAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectScheduleAppointmentRequest instance
   */
  static deserialize(json: string): StartProjectScheduleAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectScheduleAppointmentRequest instance
   */
  static fromObject(obj: any): StartProjectScheduleAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectScheduleAppointmentRequest');
    }


    const instance: StartProjectScheduleAppointmentRequest = {
      start: obj['Start'] as string | undefined,
      duration: obj['Duration'] as string | undefined,
      name: obj['Name'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectScheduleAppointmentRequest instances
   */
  static deserializeArray(json: string): StartProjectScheduleAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectScheduleAppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartProjectScheduleAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectScheduleAppointmentRequest instance to a plain object
   */
  static toObject(instance: StartProjectScheduleAppointmentRequest): any {
    return {
      'Start': instance.start,
      'Duration': instance.duration,
      'Name': instance.name,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartProjectScheduleAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectScheduleAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
